<template>
  <div class="outer-box">
    <h4>Skip 3DS For Purchase Number Flow</h4>

    <div class="inner-box" style="text-align: left; width: 500px">
      <input class="hl_input--wrap" type="text" placeholder="Location ID" v-model="locationId" />

      <button class="btn btn-primary mt-4" @click="skipPaymentIntentForLocation">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else> Skip 3DS Verification </span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa; padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { LCPhoneService } from "@/services";

export default {
  data() {
    return {
      locationId: "",
      processing: false,
      response: null,
    };
  },
  methods: {
    async skipPaymentIntentForLocation() {
      try {
        this.processing = true;
        this.response = await LCPhoneService.skipLocation3dsVerification(this.locationId);
      } catch (err) {
        this.response = err.response.data;
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>
